module.exports = __webpack_public_path__ + "static/media/mock-up-all-application.a6b285e6.png";